import CloseSVG from '@public/icons/close-btn.svg';
import { useRef } from 'react';
import { TransformedCard } from '@/shared/api/lib/utils/transform-program';
import { useMediaQueryDeviceStateValue } from '@/shared/atoms/media-query-device';
import { useSetOpenedPopupsState } from '@/shared/atoms/opened-popups';
import Popup from '@/shared/components/shared/Popup';
import Constructor from '../../constructor/Constructor';
import Typografed from '../../shared/Typografed';
import { SCHEMA_POPUP_NAME } from '../SchemaPopup/SchemaPopup';

interface Props {
    program: TransformedCard;
    disableDirections: boolean;
}

export const PROGRAM_DETAIL_POPUP = 'program-detail-popup';

function ProgramDetailPopup({ program, disableDirections }: Props) {
    const { closePopup } = useSetOpenedPopupsState();
    const popupRef = useRef<HTMLDivElement>(null);
    const device = useMediaQueryDeviceStateValue();
    const isMobile = device.includes('mobile');
    const { openPopup } = useSetOpenedPopupsState();

    const anchors = [
        { id: 'info', text: 'Описание' },
        ...(program.content?.map((block, index) => ({
            id: `anchor-${index + 1}`,
            text: block.properties?.title || `Раздел ${index + 1}`,
        })) || []),
    ];

    return (
        <Popup
            name={PROGRAM_DETAIL_POPUP}
            data-popup-preset="slide-right"
            className="program-detail-popup"
            overlay={true}
            ref={popupRef}
        >
            <div className="menu-popup-close-btn-wrapper">
                <button
                    className="menu-popup-close-btn"
                    onClick={() => {
                        closePopup(PROGRAM_DETAIL_POPUP);
                    }}
                    aria-label="Закрыть"
                >
                    <CloseSVG />
                </button>
            </div>
            <div className="program-detail-popup-top">
                {program.name && (
                    <div className="program-detail-popup-title text-l">
                        <Typografed>{program.name}</Typografed>
                    </div>
                )}
                {program.prefix && (
                    <div className="program-detail-popup-title program-detail-popup-title--prefix text-xs text-opacity">
                        <Typografed>{program.prefix}</Typografed>
                    </div>
                )}
            </div>
            <div className="program-detail-popup-content">
                <div className="program-detail-popup-info" id="info">
                    <div className="program-detail-popup-info-item">
                        <div className="program-detail-popup-info-item-title text-xs">Дата и время:</div>
                        <div className="program-detail-popup-info-item-text text-s">
                            {isMobile ? (
                                <div>
                                    <span className="program-detail-popup-info-item-text--day">{program.day}</span>

                                    <span className="program-detail-popup-info-item-text--time">
                                        ,&nbsp;{program.time}
                                    </span>
                                </div>
                            ) : (
                                <>
                                    <p className="program-detail-popup-info-item-text--day">{program.day}</p>
                                    <p className="program-detail-popup-info-item-text--time">{program.time}</p>
                                </>
                            )}
                        </div>
                    </div>
                    {!disableDirections && (
                        <div className="program-detail-popup-info-item">
                            <div className="program-detail-popup-info-item-title text-xs">Направление:</div>
                            {program && (
                                <div className="program-detail-popup-info-item-text text-s">
                                    <Typografed>{program.directions}</Typografed>
                                </div>
                            )}
                        </div>
                    )}
                    <div className="program-detail-popup-info-item">
                        <div className="program-detail-popup-info-item-title text-xs">Место:</div>
                        {program && program.place && (
                            <a
                                className="program-detail-popup-info-item-text program-detail-popup-place text-s"
                                onClick={() => {
                                    if (program.place?.image) {
                                        openPopup(SCHEMA_POPUP_NAME);
                                    }
                                }}
                            >
                                <Typografed>{program.place.name}</Typografed>
                            </a>
                        )}
                    </div>
                    <div className="program-detail-popup-info-item">
                        <div className="program-detail-popup-info-item-title text-xs">Формат участия</div>
                        {program?.participationFormats && program?.participationFormats.length > 0 ? (
                            <div className="program-detail-popup-info-item-text text-s">
                                <Typografed>
                                    {program.participationFormats.map((format) => format.name).join(', ')}
                                </Typografed>
                            </div>
                        ) : (
                            program.participationDescription && (
                                <div className="program-detail-popup-info-item-text text-s">
                                    <Typografed>{program.participationDescription}</Typografed>
                                </div>
                            )
                        )}
                    </div>
                </div>
                {program.description && (
                    <div
                        className="program-detail-popup-info-description text-s wysiwyg"
                        dangerouslySetInnerHTML={{ __html: program.description }}
                    ></div>
                )}
                {program && program.content && program.content.length > 0 && (
                    <Constructor blocks={program.content} navData={anchors} className="service-detail-section" />
                )}
            </div>
        </Popup>
    );
}

export default ProgramDetailPopup;
